import { useEffect } from 'react';

import useClipboard from 'react-use-clipboard';

import Icon from '~/src/common/components/Icon';
import { Tooltip } from '~/src/common/components/Tooltip';
import { setClientCookie } from '~/src/common/services/cookies';
import I18n from '~/src/common/services/I18n';
import { isColor } from '~/src/common/utils/guards';

import { PropsFromInputs } from '../../types';

import { Button, Content } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ code, title, textColor, iconColor }: Props) => {
  const [done, copy] = useClipboard(code, { successDuration: 1500 });
  const icon = done ? 'valid-small' : 'copy';

  // Set le cookie avec le code promo affiché sur la page (si plusieurs codes promo sont affichés, seul le dernier chargé sera enregistré)
  useEffect(() => {
    setClientCookie('promoCode', code);
  }, [code]);

  // Copie le code promo dans le presse-papier et set le cookie au clic sur le bouton
  // Permet d'écraser le code promo s'il est différent du dernier chargé sur la page
  const handleCopy = () => {
    copy();
    setClientCookie('promoCode', code);
  };

  return (
    <Button onClick={handleCopy} title={title}>
      <Tooltip visible={done} placement="bottom" content={I18n.t('landing.tooltip-copy-promocode')}>
        <Content $textColor={isColor(textColor) ? textColor : 'ACTION_DEFAULT'}>
          <code>{code}</code>
          <Icon name={icon} color={isColor(iconColor) ? iconColor : 'NEUTRAL_DEFAULT'} />
        </Content>
      </Tooltip>
    </Button>
  );
};
